// Indirection keeps the auth store out of the widget bundle: the app injects
// its token provider in main.tsx, the widget never does and stays anonymous.
let getAccessToken = () => undefined as string | undefined;

export const configureAccessToken = (provider: () => string | undefined) => {
  getAccessToken = provider;
};

export const readAccessToken = () => getAccessToken();
